import { EuiIconTip } from "@elastic/eui";
import React from "react";

export const HelpTooltip = (props) =>{

  let {message,position, adjust} = props;

  return (
    <EuiIconTip
        content={message}
        position={position || "right"}
        type="iInCircle"
        iconProps={adjust ?  {style:{color:"#006BB4"}} : {style:{width:"20px", height:"20px",color:"#006BB4"}}}
    />
  )
}